import "./webrtc.js";
import "./listener.js";
var WebRtcUtil = /** @class */ (function () {
    function WebRtcUtil($http, $q, BASE_URL) {
        this.$http = $http;
        this.BASE_URL = BASE_URL;
        this.WebRTC = window['WebRTC'];
        this.WebRTCListener = window['WebRTCListener'];
        this.deferred = $q.defer();
    }
    WebRtcUtil.prototype.$onInit = function () {
        this.executed = false;
    };
    WebRtcUtil.prototype.initWebRtcListener = function () {
        var _this = this;
        if (!this.executed) {
            this.executed = true;
            this.$http.get(this.BASE_URL + '/sip-config').then(function (config) {
                console.log("Listener with config: ", config);
                _this.WebRTCListener.init();
                _this.WebRTCListener.fakeLocalStream();
                _this.WebRTC.init(config.data, function () {
                    return _this.deferred.resolve();
                });
            });
        }
    };
    WebRtcUtil.prototype.startListening = function (agentId) {
        var _this = this;
        console.log("Starting listener");
        return this.deferred.promise.then(function () {
            return _this.$http.post(_this.BASE_URL + '/listening/' + agentId).then(function (response) {
                console.log("Started listening");
                return response;
            }, function (error) {
                console.log(error);
                return error;
            });
        });
    };
    WebRtcUtil.prototype.stopListening = function () {
        console.log("stopping listener");
        this.WebRTC.hangup();
    };
    WebRtcUtil.$inject = ['$http', '$q', 'BASE_URL'];
    return WebRtcUtil;
}());
export default WebRtcUtil;
//# sourceMappingURL=webrtc.util.js.map